import { Box, Stack } from '@mui/material';
import { SMSAutoResponse } from 'domains/content/types';
import DeleteButton from 'domains/core/components/DeleteButton';
import KeywordsInput from './KeywordsInput';
import FollowUpMessageInput from './FollowUpMessageInput';

const autoResponseWrapperStyles = {
    alignSelf: 'flex-start',
    border: '1px solid',
    borderColor: 'other.divider',
    borderRadius: '6px',
    marginTop: '16px',
    maxWidth: '725px',
    padding: '24px 12px 12px 22px',
};

type Props = {
    autoResponse: SMSAutoResponse;
    keywordsUsed: string[];
    removeAutoResponse: () => void;
    setHasInvalidAutoResponses: (hasInvalidAutoResponses: boolean) => void;
    updateAutoResponse: (autoResponse: SMSAutoResponse) => void;
};

const AutoResponse = ({
    autoResponse,
    keywordsUsed,
    removeAutoResponse,
    setHasInvalidAutoResponses,
    updateAutoResponse,
}: Props) => (
    <Stack flexDirection="row" sx={autoResponseWrapperStyles}>
        <Box flex={1}>
            <KeywordsInput
                autoResponse={autoResponse}
                keywordsUsed={keywordsUsed}
                setHasInvalidAutoResponses={setHasInvalidAutoResponses}
                updateAutoResponse={updateAutoResponse}
            />
            <FollowUpMessageInput autoResponse={autoResponse} updateAutoResponse={updateAutoResponse} />
        </Box>
        <DeleteButton onClick={removeAutoResponse} sx={{ alignSelf: 'flex-start', marginLeft: '12px' }} />
    </Stack>
);

export default AutoResponse;
